import { PersonDetailRole } from './PersonDetailRole';
import './PersonDetailRoles.scss';

// Decision level priority order (lower index = higher priority)
const DECISION_LEVEL_PRIORITY: Record<string, number> = {
  'executive': 0,
  'functional leader': 1,
  'school leadership': 2,
  'operational support': 3,
  'practitioner': 4,
};

interface Role {
  role?: string;
  area?: string;
  modifier?: string;
  title?: string;
  rank?: number | null;
  decisionLevel?: string | null;
  institution?: {
    id: string;
    name?: string;
    type?: string;
    loc_state?: string;
  };
}

interface PersonDetailRolesProps {
  roles: Role[];
}

export function PersonDetailRoles({ roles }: PersonDetailRolesProps) {
  if (!roles?.length) {
    return null;
  }

  // Sort roles by decision level priority first, then by rank as tiebreaker
  const sortedRoles = [...roles].sort((a, b) => {
    const aPriority = a.decisionLevel ? (DECISION_LEVEL_PRIORITY[a.decisionLevel.toLowerCase()] ?? 999) : 999;
    const bPriority = b.decisionLevel ? (DECISION_LEVEL_PRIORITY[b.decisionLevel.toLowerCase()] ?? 999) : 999;

    // Primary sort: decision level priority (lower = better)
    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    // Tiebreaker: rank (higher = better)
    if (a.rank == null && b.rank == null) return 0;
    if (a.rank == null) return 1;
    if (b.rank == null) return -1;
    return b.rank - a.rank;
  });

  return (
    <div className="person-detail-roles">
      <h3 className="person-detail-roles__title">Roles ({roles.length})</h3>
      <div className="person-detail-roles__grid">
        {sortedRoles.map((role, index) => (
          <PersonDetailRole key={index} role={role} />
        ))}
      </div>
    </div>
  );
}
